import React from "react";

const DownArrow = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M18 20.445L30.445 8 34 11.555l-16 16-16-16L5.555 8 18 20.445z" fill={fill}/>
    </svg>
);

export default DownArrow;